import GlobalActionTypes from './global.types';

const INITIAL_STATE = {
  currentPath: '',
  sidebarHidden: false,
  currentCustomerInformation: null,
  isAuthenticated: false,
  token: null,
  user: null
};

const globalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GlobalActionTypes.SET_CURRENT_PATH:
      return {
        ...state,
        currentPath: action.payload
      };
    case GlobalActionTypes.TOGGLE_SIDEBAR_HIDDEN:
      return {
        ...state,
        sidebarHidden: !state.sidebarHidden
      };
    case GlobalActionTypes.SELECT_CUSTOMER_INFORMATION:
      return {
        ...state,
        currentCustomerInformation: action.payload
      };
    case GlobalActionTypes.SET_AUTHENTICATED:
      localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        ...action.payload
      };
    case GlobalActionTypes.SET_USER:
      return {
        ...state,
        user: action.payload
      };
    case GlobalActionTypes.LOGOUT:
      localStorage.removeItem('token');
      return {
        ...state,
        isAuthenticated: false,
        token: null,
        user: null
      };
    default:
      return state;
  }
};

export default globalReducer;
